import { render, staticRenderFns } from "./ShuangYue.vue?vue&type=template&id=4eda92f8&scoped=true&"
import script from "./ShuangYue.vue?vue&type=script&lang=js&"
export * from "./ShuangYue.vue?vue&type=script&lang=js&"
import style0 from "./ShuangYue.vue?vue&type=style&index=0&id=4eda92f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eda92f8",
  null
  
)

export default component.exports